import { hydrateRoot } from 'react-dom/client';
import { IApplicationContext } from 'shared/common/types/applicationContext';
import { TReduxStore } from 'shared/common/types/redux';
import { loadableReady } from '@loadable/component';
import { RootApplicationContainer } from '../../../shared/common/containers/RootApplicationContainer';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export async function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const { config, custom } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  await loadableReady(
    () => {
      hydrateRoot(rootElement, <RootApplicationContainer context={context} reduxStore={store} />);
    },
    { namespace: custom.pageName },
  );
}
